import {
	Flex, For, Separator, Stack, Text,
} from '@chakra-ui/react';
import type { StackProps } from '@chakra-ui/react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { AppRoutes, CompanyInfo } from '@/constants';
import { NextLinkWrapper } from '@/modules/navigation/presentation/components';
import { PlusUpLogo } from '@/modules/shared';

export const Footer = (props: StackProps) => {
	const t = useTranslations();

	const year = new Date().getFullYear();
	const copyright = `Copyright © ${year}, PLUS UP RECRUIT`;

	const links = [
		{ href: AppRoutes.static.faq, label: t('navigation.faq') },
		{ href: AppRoutes.static.contactUs, label: t('navigation.contactUs') },
		{ href: AppRoutes.static.privacyPolicy, label: t('navigation.privacyPolicy') },
		{ href: AppRoutes.static.termsAndConditions, label: t('navigation.termsAndConditions') },
	] as const;

	return (
		<Stack gap="md" {...props}>
			<Flex alignItems="flex-start" justifyContent="space-between">
				<PlusUpLogo />
				<Stack gap="sm">
					<For each={links}>
						{link => (
							<NextLinkWrapper href={link.href} key={link.href}>
								{link.label}
							</NextLinkWrapper>
						)}
					</For>
				</Stack>
				<Stack gap="sm">
					<Text whiteSpace="pre-line">
						{t(CompanyInfo.address)}
					</Text>
					<Text>
						{CompanyInfo.phone}
					</Text>
					<Text>
						{CompanyInfo.email}
					</Text>
					<Flex gap="md">
						<For each={CompanyInfo.socialMedia}>
							{item => (
								<NextLinkWrapper href={item.href as never} isNewTab key={item.href}>
									<Image
										alt={item.image.alt}
										height={40}
										src={item.image.src}
										width={40}
									/>
								</NextLinkWrapper>
							)}
						</For>
					</Flex>
				</Stack>
			</Flex>
			<Separator borderColor="gray.50" />
			<Text opacity={0.5} textAlign="center">
				{copyright}
			</Text>
		</Stack>
	);
};
